import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import Currency from 'components/currency';
import Button from 'components/button/cart';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import MainContext from 'MainContext';

const Wrapper = styled.div`
  position: absolute;
  bottom: 3.331vw;
  left: 2.811vw;
  width: 20.926vw;
  height: 7.027vw;
  border-radius: 1.718vw;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.pure};
`;

const StyledDiv = styled.div`
  width: 100%;
  height: 3.591vw;
  font-size: 1.145vw;
  font-weight: 500;
  color: ${(props) => props.theme.textPrimary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.56vw;
  padding-right: 1.56vw;
  box-sizing: border-box;
`;

const App = (props) => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();
  const { totalPrice, setShowBasket, orderRFQ } = props;
  // const { orderRFQ } = useContext(MainContext).cart;

  return (
    <Wrapper theme={theme}>
      <StyledDiv theme={theme}>
        <div>{t('cart.button.Total')} {orderRFQ && '+ RFQ'}</div>
        <Currency value={totalPrice} /> 
      </StyledDiv>
      <Link to="/checkout" style={{ textDecoration: 'none' }}>
        <Button text={t('cart.button.Submit')} onClick={() => setShowBasket(false)} />
      </Link>
    </Wrapper>
  );
};

export default App;
